import React from 'react';

import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface IProps {
  label: string;
  tooltip?: string;
}

const ChecklistBadge: React.FC<IProps> = ({ label, tooltip }) => {
  const badge = (
    <Badge variant={tooltip ? 'secondary' : 'outline'}>{label}</Badge>
  );

  if (!tooltip) {
    return badge;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>{badge}</span>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ChecklistBadge;
